import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { Divider, Card, Radio } from '@material-ui/core';
import { isEmpty, isArray } from 'lodash';
import classNames from 'classnames';
import { ADGMImage, ADGMPagination, ADGMItemDetails } from 'aurora-components';
import NoDataScreen from '../../NoDataScreen';
import styles from './styles';

const GovernmentBuyer = ({
  classes,
  locale,
  currentPage,
  companiesResponse,
  selectedCompanyId,
  showNoResultScreen,
  onCompanySelectHandler,
  onPageChangeHandler,
  clearCompaniesResponseHandler,
}) => {
  useEffect(() => {
    return clearCompaniesResponseHandler;
  }, []);

  const renderCompanyCard = company => {
    const isSelected = !!(selectedCompanyId && company?.companyId === selectedCompanyId);
    return (
      <Card
        key={company?.id}
        className={classNames(classes.companyCard, {
          [classes.companyCardSelected]: isSelected,
        })}
        onClick={() => onCompanySelectHandler(company)}
      >
        <div className={classes.companyNameAndIconHolder}>
          <Radio className={classes.companyCardRadioButton} checked={isSelected} />
          <ADGMImage name='company_profile.svg' alt='add-company' />
          <div className={classes.companyNameHolder}>
            <ADGMItemDetails
              label='Name'
              value={
                locale === 'en'
                  ? company?.companyNameEn || company?.companyNameAr
                  : company?.companyNameAr || company?.companyNameEn
              }
            />
          </div>
        </div>
        <Divider className={classes.divider} />
        <div className={classes.companyDetailsHolder}>
          <div>
            <ADGMItemDetails label='license_number' value={company?.tradeLicenseNumber} />
          </div>
          <div>
            <ADGMItemDetails label='email' value={company?.companyEmail} />
          </div>
          <div>
            <ADGMItemDetails label='phone_number' value={<bdi>{company?.mobileNumber ?? '-'}</bdi>} />
          </div>
        </div>
      </Card>
    );
  };

  const handlePageChange = page => {
    if (+page === currentPage) return;
    onPageChangeHandler(+page);
  };

  return (
    <>
      <Divider className={classes.divider} />
      {showNoResultScreen && (!isArray(companiesResponse?.data) || isEmpty(companiesResponse?.data)) && (
        <NoDataScreen showCompanyIcon customClasses={{ container: classes.noDataFoundHolder }} />
      )}

      {isArray(companiesResponse?.data) && !isEmpty(companiesResponse?.data) && (
        <div className={classes.companyCards}>
          {companiesResponse?.data?.map(companyData => renderCompanyCard(companyData))}
        </div>
      )}

      {!isEmpty(companiesResponse?.data) && companiesResponse?.totalPages > 1 && (
        <ADGMPagination
          totalPages={companiesResponse?.totalPages || 0}
          currentPage={currentPage}
          onPageChange={handlePageChange}
          customClasses={{ container: classes.pagination }}
        />
      )}
    </>
  );
};

GovernmentBuyer.propTypes = {
  classes: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  currentPage: PropTypes.number.isRequired,
  companiesResponse: PropTypes.array.isRequired,
  selectedCompanyId: PropTypes.number.isRequired,
  showNoResultScreen: PropTypes.bool.isRequired,
  onCompanySelectHandler: PropTypes.func.isRequired,
  onPageChangeHandler: PropTypes.func.isRequired,
  clearCompaniesResponseHandler: PropTypes.func.isRequired,
};

export default withStyles(styles)(GovernmentBuyer);
